/* VK Header Cart — multi-target + reliable refresh
   - Updates ALL header cart targets (desktop + mobile)
   - No MutationObserver
   - No imports
*/

(function () {
  'use strict';

  if (window.__VK_HEADER_CART__) return;
  window.__VK_HEADER_CART__ = true;

  var CART_WRITE_RE = /\/cart\/(add|change|update)\.js(\?|$)/i;
  var inFlight = null;
  var lastSig = '';
  var refreshQueued = false;

  function formatGBP(cents) {
    var n = Number(cents || 0) / 100;
    try {
      return n.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
    } catch (_) {
      return '£' + n.toFixed(2);
    }
  }

  function getTargets() {
    var roots = document.querySelectorAll('[data-vk-cart]');
    if (!roots || !roots.length) return [];

    var out = [];
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root) continue;

      out.push({
        root: root,
        totalEls: root.querySelectorAll('[data-vk-cart-total]'),
        countEls: root.querySelectorAll('[data-vk-cart-count]'),
      });
    }
    return out;
  }

  function signature(cart) {
    if (!cart) return 'null';
    return String(cart.item_count || 0) + ':' + String(cart.total_price || 0) + ':' + String(cart.token || '');
  }

  function applyCart(cart) {
    if (!cart) return;

    var sig = signature(cart);
    if (sig === lastSig) return;
    lastSig = sig;

    var total = Number(cart.total_price || 0);
    var count = Number(cart.item_count || 0);
    var targets = getTargets();
    if (!targets.length) return;

    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];

      // totals (write only if changed)
var nextTotal = formatGBP(total);
for (var a = 0; a < t.totalEls.length; a++) {
  var totalEl = t.totalEls[a];
  if (totalEl && totalEl.textContent !== nextTotal) {
    totalEl.textContent = nextTotal;
  }
}

// counts (write only if changed)
var nextCount = String(count);
for (var b = 0; b < t.countEls.length; b++) {
  var el = t.countEls[b];
  if (!el) continue;

  if (count > 0) {
    if (el.hidden) el.hidden = false;
    if (el.textContent !== nextCount) el.textContent = nextCount;
  } else {
    if (!el.hidden) el.hidden = true;
    if (el.textContent !== '0') el.textContent = '0';
  }
}
    }
  }

  function fetchCart() {
    if (inFlight) return inFlight;

    inFlight = fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        inFlight = null;
      });

    return inFlight;
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      if (!cart) return;
      applyCart(cart);
    });
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.setTimeout(function () {
      refreshQueued = false;
      refresh();
    }, 0);
  }

  // Patch fetch: refresh after cart writes complete
  (function patchFetch() {
    if (!window.fetch) return;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (_) {
        url = '';
      }

      var isCartWrite = CART_WRITE_RE.test(url);

      return originalFetch.apply(this, args).then(function (res) {
        if (isCartWrite) queueRefresh();
        return res;
      });
    };
  })();

  document.addEventListener('vk:cart:updated', function () {
    queueRefresh();
  });

  window.addEventListener('pageshow', function () { queueRefresh(); });
  window.addEventListener('focus', function () { queueRefresh(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') queueRefresh();
  });

  // Initial
  queueRefresh();
})();